import { useContext } from 'react'
import PublicUserAuthContext from './PublicUserAuthProvider.context'

/**
 * The PublicUserAuthProvider's custom hook.
 */
export const usePublicUserAuthProvider = () => useContext(PublicUserAuthContext)
